import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import { useMenuOptions } from "../../../../Api/ingredientsApi";
import Popup from "../../../../components/Popup";
import { ProductsDetailsContext } from "../../ProductsProvider";
export var MenuPopup = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var isOpen = _a.isOpen, setOpen = _a.setOpen;
    /** @ts-ignore */
    var _h = useContext(ProductsDetailsContext), submit = _h.submit, storeId = _h.storeId;
    var _j = useState(0), page = _j[0], setPage = _j[1];
    var _k = useMenuOptions(storeId), menuOptions = _k.menuOptions, error = _k.error;
    var formik = useFormik({
        initialValues: {
            bread: reactConfig.breadId,
            dip: null,
            drink: null,
        },
        onSubmit: function (values, _a) {
            var resetForm = _a.resetForm;
            submit(undefined, undefined, undefined, Object.values(values));
            resetForm();
        },
    });
    if (!(((_b = menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions["default"]) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
        ((_c = menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions["BREAD"]) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
        ((_d = menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions["DRINK"]) === null || _d === void 0 ? void 0 : _d.length) > 0)) {
        return null;
    }
    return (React.createElement(Popup, { open: isOpen, handleClose: function () { setOpen(false); setPage(0); }, title: "Spar-Men\u00FC", subtitle: "Spare bis zu 30% \uD83D\uDD25", position: "bottom", customStyle: "menu-options", isClosable: true },
        React.createElement("div", { className: "menu-popup" }, page === 0 ? (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Brote & Dips (einen Dip ausw\u00E4hlen)"), (_e = menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions["default"]) === null || _e === void 0 ? void 0 :
            _e.map(function (menuOption, index) {
                return (React.createElement(MenuOption, { menuOption: menuOption, value: formik.values.bread, name: "bread-" + index, key: "bread-" + index, onChange: function () {
                        formik.setFieldValue("bread", menuOption.id);
                    } }));
            }),
            React.createElement("hr", null), (_f = menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions["BREAD"]) === null || _f === void 0 ? void 0 :
            _f.map(function (menuOption, index) {
                return (React.createElement(MenuOption, { menuOption: menuOption, value: formik.values.dip, name: "dip-" + index, key: "dip-" + index, onChange: function () {
                        formik.setFieldValue("dip", menuOption.id);
                    } }));
            }))) : (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Getr\u00E4nk (ein Getr\u00E4nk ausw\u00E4hlen)"), (_g = menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions["DRINK"]) === null || _g === void 0 ? void 0 :
            _g.map(function (menuOption, index) {
                return (React.createElement(MenuOption, { menuOption: menuOption, value: formik.values.drink, name: "drink-" + index, key: "drink-" + index, onChange: function () {
                        formik.setFieldValue("drink", menuOption.id);
                    } }));
            })))),
        React.createElement("button", { onClick: function () {
                if (page === 0)
                    setPage(1);
                else {
                    formik.submitForm();
                    setOpen(false);
                    setPage(0);
                }
            }, className: "btn btn__primary btn__SM", disabled: page === 0
                ? !formik.values.dip
                : !formik.values.drink }, page === 0
            ? "Getränk auswählen"
            : "Spar-Menü hinzufügen")));
};
var MenuOption = function (_a) {
    var menuOption = _a.menuOption, name = _a.name, value = _a.value, onChange = _a.onChange;
    return (React.createElement("label", { className: "menu-radio-option", style: { display: "grid" } },
        React.createElement("input", { type: "radio", name: name, value: menuOption.id, checked: menuOption.id === value, onChange: onChange, style: { gridArea: "1/1", display: "hidden" } }),
        React.createElement("span", { style: { gridArea: "1/1" } },
            React.createElement("img", { src: menuOption.primary_image.small_url, alt: "" }),
            menuOption.name)));
};
